// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.celebration-moments-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px;
}
.celebration-moments-container img {
  max-width: 100%;
}
.celebration-moments-container .sub-text {
  margin-top: 12px;
  text-align: left;
}
.celebration-moments-container button {
  margin-top: 12px;
  font-weight: normal;
  cursor: pointer;
}
.celebration-moments-container button span {
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/widget/style.less"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AACJ;AAPA;EAQQ,eAAA;AAER;AAVA;EAWQ,gBAAA;EACA,gBAAA;AAER;AAdA;EAkBQ,gBAAA;EACA,mBAAA;EACA,eAAA;AADR;AAnBA;EAgBY,oBAAA;AAMZ","sourcesContent":[".celebration-moments-container {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    font-size: 14px;\n    img {\n        max-width: 100%;\n    }\n    .sub-text {\n        margin-top: 12px;\n        text-align: left;\n    }\n    button {\n        span {\n            pointer-events: none;\n        }\n        margin-top: 12px;\n        font-weight: normal;\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
